import { auth } from 'api';
import {
  SET_AUTH_PROPERTY,
  RECOVERY_PASSWORD,
  CHANGE_PASSWORD,
  NEW_DRIVER,
  CONFIRM_NEW_DRIVER,
  POST_LOGIN_IDENTITY,
  SET_USER_INFO,
  GET_LOGOUT,
  RESTORE_SESSION,
  POST_USER_SESSION,
  GET_USER_INFO
} from 'store/actions/auth';
import { encryptIdentifier } from 'helpers/encrypt';
import {
  lsRemoveLoginProfile,
  lsGetLoginProfile,
  lsRemoveDataSignout,
  lsSetLoginProfile
} from 'helpers/store';

export default {
  [SET_AUTH_PROPERTY]: ({ commit }, { field, value }) =>
    commit(SET_AUTH_PROPERTY, { field, value }),

  [POST_LOGIN_IDENTITY]: (_, { user, password }) =>
    new Promise((resolve, reject) => {
      lsRemoveLoginProfile();
      auth.postLoginIdentity({ user, password }).then(
        resp => {
          if (resp.data.redirectUrl) {
            window.location.href = resp.data.redirectUrl;
          } else {
            // eslint-disable-next-line prefer-promise-reject-errors
            reject({
              message: 'Falta la url de redirección al login corporativo'
            });
          }
        },
        err => {
          console.log('Error POST_LOGIN_IDENTITY ', err.response);
          reject(err.response.data);
        }
      );
    }),

  [POST_USER_SESSION]: ({ commit }, payload) =>
    new Promise((resolve, reject) => {
      auth.postUserSession(payload).then(
        () => {
          resolve();
        },
        err => {
          commit('ERROR_OCCURRED', err, { root: true });
          reject(err.response.data);
        }
      );
    }),

  [GET_USER_INFO]: ({ commit }) =>
    new Promise((resolve, reject) => {
      lsRemoveLoginProfile();

      auth.userInfo().then(
        resp => {
          lsSetLoginProfile(resp.data);
          commit(SET_USER_INFO, resp.data);
          resolve();
        },
        err => {
          /* Error al obtener el perfil ESTO FALTA POR CONTROLAR */
          commit('ERROR_OCCURRED', err, { root: true });
          reject();
        }
      );
    }),

  [RECOVERY_PASSWORD]: (_, { email }) =>
    new Promise((resolve, reject) => {
      auth
        .recoveryPassword({ email })
        .then(() => {
          resolve();
        })
        .catch(() => reject());
    }),

  [CHANGE_PASSWORD]: (_, { password, newPassword, idDriver }) =>
    new Promise((resolve, reject) => {
      auth
        .changePassword({ password, newPassword, idDriver })
        .then(() => {
          resolve();
        })
        .catch(() => reject());
    }),

  [NEW_DRIVER]: ({ commit }, { email, dni, plate }) =>
    new Promise((resolve, reject) => {
      auth
        .newDriver({ email, dni, plate })
        .then(resp => {
          const data = resp.data;
          commit(NEW_DRIVER, { driver: data.driver });
          resolve(data);
        })
        .catch(() => reject());
    }),

  [CONFIRM_NEW_DRIVER]: (_, { driverInfo }) =>
    new Promise((resolve, reject) => {
      const driverIdEncrypted = encryptIdentifier(driverInfo.driverId);
      auth
        .confirmNewDriver(driverIdEncrypted)
        .then(() => {
          resolve();
        })
        .catch(() => reject());
    }),

  [GET_LOGOUT]: ({ dispatch }) =>
    new Promise((resolve, reject) => {
      auth.getLogout().then(
        async resp => {
          if (resp.data.redirectUrl) {
            lsRemoveDataSignout();
            lsRemoveLoginProfile();
            await dispatch(SET_AUTH_PROPERTY, { field: 'userInfo', value: null });
            window.location.href = resp.data.redirectUrl;
          } else {
            // eslint-disable-next-line prefer-promise-reject-errors
            reject({
              message: 'Falta la url de redirección al logout corporativo'
            });
          }
        },
        err => {
          reject(err);
        }
      );
    }),

  [RESTORE_SESSION]: ({ commit, getters }) =>
    new Promise(resolve => {
      let userInfo = getters.data('userInfo');

      if (!userInfo) {
        userInfo = lsGetLoginProfile();

        if (userInfo) {
          commit(SET_USER_INFO, userInfo);
        }
      }

      resolve(userInfo);
    })
};
